import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FiX } from 'react-icons/fi';

import ContractorAuthenticationModal from '../../../components/family-plaza/ContractorAuthenticationModal';
import PortraitPhotoRegistrationModal from '../../../components/family-plaza/PortraitPhotoRegistrationModal';
import { checkModalAuthenticationStatus, requireAuthentication } from '../../../utils/authUtils';
import { getCurrentCustomerName, getDeceasedPersonDate, getDeceasedPersonProfileText } from '../../../utils/profilePhotoUtils';
import { getCherishMessages } from '../../../api';
import FamilyPlazaTopSection from '../../../components/family-plaza/FamilyPlazaTopSection';
import FamilyPlazaSubHeading from '../../../components/family-plaza/FamilyPlazaSubHeading';
import CyberMemorialService from '../../../services/FamilyPlaza/CyberMemorialService';
import DeceasedPersonProfile from '../../../components/family-plaza/DeceasedPersonProfile';

const DonatePC = () => {
   const navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [donations, setDonations] = useState([]);
  const [profilePhotoUrl, setProfilePhotoUrl] = useState('');
  
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [hasMoreDonations, setHasMoreDonations] = useState(false);
  const [donationsPerPage] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [allDonations, setAllDonations] = useState([]); // Store all donations
  const [displayedDonations, setDisplayedDonations] = useState([]); // Store currently displayed donations

  

  // Photo icon click handler
  // const handlePhotoIconClick = () => {
  //   setShowAuthModal(true);
  // };


  const handlePhotoIconClick = () => {
    const isAuthenticated = checkModalAuthenticationStatus();
    
    if (isAuthenticated) {
      // If already authenticated, open photo modal directly
      setShowPhotoModal(true);
    } else {
      // If not authenticated, open auth modal first
      setShowAuthModal(true);
    }
  };

  // Authentication modal handlers
  const handleAuthConfirm = () => {
    setShowAuthModal(false);
    // After successful authentication, navigate to donation registration page
    // navigate('/donate-registration');
  };

  const handleAuthClose = () => {
    setShowAuthModal(false);
  };

  // Photo registration modal handlers
  const handlePhotoConfirm = () => {
    setShowPhotoModal(false);
    navigate(-1); 
  };

  const handlePhotoClose = () => {
    setShowPhotoModal(false);
  };

  // Handle donation removal
  const handleDonationRemove = (donationId) => {
    // Show confirmation alert
    const isConfirmed = window.confirm("정말 삭제하시겠습니까?");
    
    if (isConfirmed) {
      console.log('🗑️ Attempting to delete donation with ID:', donationId);
      console.log('📋 Current donations:', donations);
      
      // Find the specific donation to delete
      const donationToDelete = donations.find(donation => donation.layflowerId === donationId);
      if (!donationToDelete) {
        console.error('❌ Donation not found for deletion:', donationId);
        alert('삭제할 항목을 찾을 수 없습니다.');
        return;
      }
      
      // For now, just show success message - no actual deletion
      alert("삭제되었습니다.");
    }
  };

  // Handle checkbox and button click
  const handleDonateClick = () => {
    // Check if user has already completed the authentication modal
    if (checkModalAuthenticationStatus()) {
      // If already authenticated, navigate directly to registration page
      navigate('/donate-registration');
    } else {
      // If not authenticated, show authentication modal
      setShowAuthModal(true);
    }
  };

  // Handle load more donations
  const handleLoadMore = async () => {
    if (isLoading || currentPage >= totalPages) return;
    
    setIsLoading(true);
    try {
      const nextPage = currentPage + 1;
      const startIndex = (nextPage - 1) * donationsPerPage;
      const endIndex = startIndex + donationsPerPage;
      
      // Get next batch of donations from allDonations
      const nextBatch = allDonations.slice(startIndex, endIndex);
      
      if (nextBatch.length > 0) {
        setDonations(prevDonations => [...prevDonations, ...nextBatch]);
        setDisplayedDonations(prev => [...prev, ...nextBatch]);
        setCurrentPage(nextPage);
        setHasMoreDonations(endIndex < allDonations.length);
      }
    } catch (error) {
      console.error('Error loading more donations:', error);
    } finally {
      setIsLoading(false);
    }
  };

  

    // Load donations from API
    const loadDonations = async () => {
      setIsLoading(true);
      try {
        const selectedPersonData = localStorage.getItem('selectedPersonData');
        if (selectedPersonData) {
          const personData = JSON.parse(selectedPersonData);
          const goinId = personData.goinId;
          
          if (goinId) {
            const response = await CyberMemorialService.getLayflowersByGoinId(goinId, 1, 200);
            
            if (response && response.layflowers) {
              // Sort by registration time (latest first) and store all donations
              const sortedDonations = [...response.layflowers].sort((a, b) => 
                new Date(b.registTime) - new Date(a.registTime)
              );
              setAllDonations(sortedDonations);
              setTotalItems(sortedDonations.length);
              
              // Show first 10 donations
              const firstPage = sortedDonations.slice(0, donationsPerPage);
              setDisplayedDonations(firstPage);
              setDonations(firstPage);
              setCurrentPage(1);
              setTotalPages(Math.ceil(sortedDonations.length / donationsPerPage));
              setHasMoreDonations(sortedDonations.length > donationsPerPage);
            } else {
              setDonations([]);
              setCurrentPage(1);
              setTotalPages(0);
              setTotalItems(0);
              setHasMoreDonations(false);
            }
          } else {
            setDonations([]);
            setCurrentPage(1);
            setTotalPages(0);
            setTotalItems(0);
            setHasMoreDonations(false);
          }
        } else {
          setDonations([]);
          setCurrentPage(1);
          setTotalPages(0);
          setTotalItems(0);
          setHasMoreDonations(false);
        }
      } catch (error) {
        console.error('❌ Error loading donations from API:', error);
        setDonations([]);
        setCurrentPage(1);
        setTotalPages(0);
        setTotalItems(0);
        setHasMoreDonations(false);
      } finally {
        setIsLoading(false);
      }
    };

    useEffect(() => {
      loadDonations();

 

    // Profile photo is now loaded via API, no need for listener setup

        // Listen for donation updates
    const handleDonationUpdate = (event) => {
      // Only update if this is for the current user
      const currentPersonData = localStorage.getItem('selectedPersonData');
      let currentCustomerName = 'default';
      
      if (currentPersonData) {
        try {
          const personData = JSON.parse(currentPersonData);
          currentCustomerName = personData.customerName || 'default';
        } catch (error) {
          currentCustomerName = 'default';
        }
      }
      
              // Only update if the event is for the current user
        if (event.detail.customerName === currentCustomerName) {
          // Reload donations from API to get the latest data
          loadDonations();
        }
    };

    window.addEventListener('donationUpdated', handleDonationUpdate);

    return () => {
      window.removeEventListener('donationUpdated', handleDonationUpdate);
    };
  }, []);

  const updatePCProfilePhoto = (photoUrl) => {
    const profileImage = document.querySelector('.donate-profile-image img');
    if (profileImage) {
      profileImage.src = photoUrl;
    }
    
    // Also try alternative selectors
    const allProfileImages = document.querySelectorAll('.donate-profile-image img');
    allProfileImages.forEach(img => {
      img.src = photoUrl;
    });
  };

  const updatePCProfileData = (personData) => {
    // Update profile text content
    const profileText = document.querySelector('.donate-profile-text');
    const profileSubtext = document.querySelector('.donate-profile-subtext');
    const profileDate = document.querySelector('.donate-profile-date');
    
    if (profileText) {
      profileText.textContent = personData.goinName;
    }
    if (profileSubtext) {
      profileSubtext.textContent = `${personData.goinName}님의 사이버 추모관 입니다.`;
    }
    if (profileDate) {
      profileDate.textContent = `${personData.enshrineDay} 별세`;
    }
    
    // Reset profile photo to default when switching users
    const profileImage = document.querySelector('.donate-profile-image img');
    if (profileImage) {
      profileImage.src = '/donate/layer-1910.png';
    }
  };

  return (
    <div className="donate-pc page-donate-pc announcement-list-page donate-info-page-pc ">
   
      <FamilyPlazaTopSection />

      <main className="main-content">

      <FamilyPlazaSubHeading heading="사이버추모관" />

      {/* Main Content */}
      <div className="donate-main-content">
        <div className="donate-page-content">
          <div className="donate-container">
            
           
            <DeceasedPersonProfile 
              handlePhotoIconClick={handlePhotoIconClick}
            />

            {/* Action Tabs Navigation */}
            <div className="donate-action-tabs">
              <div className="donate-action-tabs-container">
                <ul>
                  <li><Link to="/donate" className="active">헌화하기</Link></li>
                  <li><Link to="/memorial-post-board-list">추모글</Link></li>
                  <li><Link to="/memorial-album-board-list">추모앨범</Link></li>
                </ul>
              </div>
            </div>

                         {/* Flower Gallery */}
             <div className="donate-flower-gallery">
               <div className="donate-flower-grid">
                                 {/* Show user's donations first (latest first) if they exist */}
                 {donations.map((donation) => (
                     <div key={donation.layflowerId} className="donate-flower-item">
                       <div className="donate-flower-image">
                         <img src={donation.flowerImageUrl} alt="Flowers" />
                         <button 
                           className="donate-flower-close"
                           onClick={() => handleDonationRemove(donation.layflowerId)}
                         >
                           <FiX />
                         </button>
                         <div className="donate-flower-overlay">
                           <div className="donate-flower-message">
                             <p style={{
                               display: '-webkit-box',
                               WebkitLineClamp: 2,
                               WebkitBoxOrient: 'vertical',
                               overflow: 'hidden',
                               textOverflow: 'ellipsis',
                               lineHeight: '1.2em',
                               maxHeight: '2.4em'
                             }}>
                               {donation.layflowerTitle || donation.layflowerContents}
                             </p>
                           </div>
                           <div className="donate-flower-info">
                             <p>{new Date(donation.registTime).toLocaleDateString('ko-KR')}</p>
                           </div>
                         </div>
                       </div>
                     </div>
                 ))}
                
             
               </div>
             </div>

                         {/* More Button and Content Area */}
             <div className="donate-more-section">
               <div className="donate-more-button-container">
                 <button 
                   className="donate-more-button" 
                   onClick={handleLoadMore} 
                   disabled={!hasMoreDonations || isLoading}
                 >
                   {isLoading ? '로딩 중...' : '더보기'}
                 </button>
                
               </div>
              <div className="donate-content-area">
                <div className="donate-checkbox-container">
                  <img src="/images/icon4.png" alt="Check" className="letter-to-heaven-board-list-check-icon" />
                  <label htmlFor="donate-checkbox" className="donate-checkbox-label">
                    그리고 보고싶은 사람에게 헌화하세요.
                  </label>
                </div>
                <button className="donate-write-button" onClick={handleDonateClick}>글쓰기</button>
              </div>
            </div>

          </div>
        </div>
      </div>



      {/* Authentication Modal */}
      {showAuthModal && (
        <ContractorAuthenticationModal
          isOpen={showAuthModal}
          onConfirm={handleAuthConfirm}
          onClose={handleAuthClose}
        />
      )}

      {/* Photo Registration Modal */}
      {showPhotoModal && (
        <PortraitPhotoRegistrationModal
          isOpen={showPhotoModal}
          onConfirm={handlePhotoConfirm}
          onClose={handlePhotoClose}
        />
      )}

    </main>

    </div>
  );
};

export default DonatePC; 